import NavProvider from './NavProvider';
import OverlayProvider from './OverlayProvider';
import ScrollProvider from './ScrollProvider';

function AppProvider({ children }) {
  return (
    <NavProvider>
      <ScrollProvider>
        <OverlayProvider>
          {children}
        </OverlayProvider>
      </ScrollProvider>
    </NavProvider>
  );
}

export default AppProvider;